import React, { useEffect, useState } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "./FullPageSlider.css";

import { useDispatch, useSelector } from "react-redux";
import { setNavbarDark, setSideMenuBarOpen } from "../../appState/slices/auth/authSlice";
import { ReactComponent as Logo } from '../../assets/logo/logo-name.svg';
import { Container, Row, Col, Button } from "reactstrap";
import { FacebookLogo, InstagramLogo, MapPinLine, Phone, WhatsappLogo, PinterestLogo } from "phosphor-react";
import ProductShowcase from "./ProductShowcase";
import Vault from "../Vault/Vault";
import { getVaultProducts } from "../../appState/slices/product/productSlice";
import { useNavigate } from "react-router-dom";

const FullPageSlider = () => {


  const [currentSlide, setCurrentSlide] =
    useState(0);

  const [isScrolling, setIsScrolling] =
    useState(false);

    const user = useSelector((state) => state.auth.user);
    const navigate = useNavigate();

  const dispatch = useDispatch();



  const products = useSelector(
    (state) => state.product.products
  );

  const senddesignproducts = useSelector((state) => state.product.senddesignproducts)

  const totalSlides = 5;

  /* ========================= */
  /* SCROLL HANDLER */
  /* ========================= */

  const handleScroll = (event) => {

    event.preventDefault();

    if (isScrolling) return;

    const direction =
      event.deltaY > 0 ? "down" : "up";

    setIsScrolling(true);

    if (direction === "down") {

      setCurrentSlide((prev) =>
        prev < totalSlides - 1
          ? prev + 1
          : prev
      );

    } else {

      setCurrentSlide((prev) =>
        prev > 0
          ? prev - 1
          : prev
      );

    }

    setTimeout(() => {
      setIsScrolling(false);
    }, 1800);

  };
  /* ========================= */
  /* CAROUSEL CHANGE */
  /* ========================= */

  const showedfunc = (slideIndex) => {
    setCurrentSlide(slideIndex);
  };

  /* ========================= */
  /* EFFECTS */
  /* ========================= */

  useEffect(() => {

    window.addEventListener(
      "wheel",
      handleScroll,
      { passive: false }
    );

    if (currentSlide === 0) {
      dispatch(setNavbarDark(false));
    }

    else if (currentSlide === 1) {
      dispatch(setNavbarDark(false));
    }

    else if (currentSlide === 2) {
      dispatch(setNavbarDark(true));
    }

    else if (currentSlide === 3) {
      dispatch(setNavbarDark(false));
    }

    else if (currentSlide === 4) {
      dispatch(setNavbarDark(true));
    }

    return () => {

      window.removeEventListener(
        "wheel",
        handleScroll
      );

    };



  }, [currentSlide, isScrolling]);

  const bookappointment = () => {
    if(user){
      navigate('/appointment')
    }
   else {
      const currentUrl =
        window.location.pathname + window.location.search;

      localStorage.setItem(
        "redirectAfterLogin",
        currentUrl
      );

      navigate("/login");
    }
  }

  const updateSideMenuBarOpen = () => {
      dispatch(setSideMenuBarOpen(true));
    }
  return (

    <div
      className="carousel-container"

    >
      <Carousel
        showStatus={false}
        showThumbs={false}
        showIndicators={true}
        showArrows={false}
        emulateTouch={true}
        swipeable={true}
        axis="vertical"
        selectedItem={currentSlide}
        onChange={showedfunc}
        transitionTime={700}
      >

        {/* ========================= */}
        {/* SLIDE 1 */}
        {/* ========================= */}

        <div className="slider2">

          {/* VIDEO */}

          <video
            className="store-video"
            autoPlay
            muted
            loop
            playsInline
          >
            <source
              src="https://purecarats-testing.s3.us-east-1.amazonaws.com/homepage/purecarats-store-video.mp4"
              type="video/mp4"
            />
          </video>

          {/* OVERLAY */}

          <div className="video-overlay" />

          {/* CONTENT */}

          <div className="video-content">

            <div className="video-subtitle">
              PURECARATS EXPERIENCE - BY DREAMS JEWELS SINCE 1992.
            </div>

            <div className="video-heading">
              One Stop for all your Diamond Jewellery needs
            </div>

            <div className="video-description">
              Natural Diamonds | Lab Diamonds | Solitaires everything at best price and at one place.
            </div>
    <br />
            <div className="video-button-container">

              <Button onClick={bookappointment} className="video-button">
                Book Appointment
              </Button>

              {/* <Button onClick={updateSideMenuBarOpen} className="video-button">
                Shop Products
              </Button> */}

            </div>

          </div>

        </div>

        {/* ========================= */}
        {/* SLIDE 2 */}
        {/* ========================= */}


        <Vault />




        {/* ========================= */}
        {/* SLIDE 3 */}

        <div className="hero-slide">

          {/* TEXT */}

          <div className="hero-text-content">

            <div className="hero-title">

              <div className="hero-title-question">
                Have a Design in Mind?
              </div>

              <div className="hero-title-ans">
                We will give best Price..
              </div>

            </div>

          </div>

          {/* CENTER BUTTON */}

          <div className="center-button-wrapper">

            <a className="design-cta-btn t6" href="https://wa.me/918850286201">

              Send Us
              <br />
              Your Design →

            </a>

          </div>

          {/* ORBIT */}

          <div className="orbit-container">

            <div className="orbit-item orbit-item1">
              <img
                src={senddesignproducts[0]?.defaultImageUrl}
                alt=""
              />
            </div>

            <div className="orbit-item orbit-item2">
              <img
                src={senddesignproducts[1]?.defaultImageUrl}
                alt=""
              />
            </div>

            <div className="orbit-item orbit-item3">
              <img
                src={senddesignproducts[2]?.defaultImageUrl}
                alt=""
              />
            </div>

            <div className="orbit-item orbit-item4">
              <img
                src={senddesignproducts[3]?.defaultImageUrl}
                alt=""
              />
            </div>

            <div className="orbit-item orbit-item5">
              <img
                src={senddesignproducts[4]?.defaultImageUrl}
                alt=""
              />
            </div>

            <div className="orbit-item orbit-item6">
              <img
                src={senddesignproducts[5]?.defaultImageUrl}
                alt=""
              />
            </div>

          </div>

        </div>

        {/* SLIDE 4 */}


        <ProductShowcase />
        {/* SLIDEEEEEE.   */}

        <div className="bottom-nav-slide top-padding">

          <Container
            fluid
            className="h-100"
          >

            <Row className="h-100 align-items-center">

              {/* LEFT */}

              <Col
                xs="12"
                lg="7"
              >

                <div className="bottom-brand-section">

                  <div className="bottom-brand-title">
                    <Logo className="bottom-logo-color" />
                  </div>

                  <div className="bottom-brand-description">

                    Crafted for timeless elegance,
                    modern celebrations and
                    everyday luxury.

                  </div>

    
                </div>

              </Col>

              {/* CENTER */}


              {/* RIGHT */}

              <Col
                xs="12"
                lg="5"
              >

                <div className="bottom-contact-section">

                  <div className="bottom-contact-title">
                    Connect
                  </div>

                  

                  <div className="bottom-contact-link">
                    <Phone size={32} weight="fill" /> +91 8850286201
                  </div>

                  <div className="bottom-contact-link">
                    {/* <MapPinLine size={32} weight="fill" /> */}
                    713, Kosha Kommercial Komplex, Poddar Rd, Malad East,Mumbai - 400097
                  </div>

                 

                </div>

              </Col>

              <div className="connect-items">
                  <a className="bottom-contact-link" href="https://www.instagram.com/purecarats.in/" >
                    <InstagramLogo size={32} weight="fill" />
                  </a>

                  <a className="bottom-contact-link" href="https://in.pinterest.com/purecarats/">
                    <PinterestLogo size={32} /> 
                  </a>

                  <a className="bottom-contact-link" href="https://wa.me/918850286201">
                    <WhatsappLogo size={32} weight="fill" /> 
                  </a>
                  </div>

                   <button onClick={bookappointment} className="bottom-appointment-btn">
                    Book Appointment
                  </button>

            </Row>


          </Container>
          <div className="bottom-copyright">
            Designed by Dhruvil Shah &nbsp;
            Copyright © 2026, Purecarats.
            All Rights Reserved.
          </div>
        </div>


      </Carousel>

    </div>

  );
};

export default FullPageSlider;